import React, { Component } from 'react';
import './Loading.css';

export default class Loading extends Component {
  render() {
    return (
      <div className="loading">Loading&#8230;</div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/componenets/shared/Loading.js